// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agent-queue/page"
import Pending from "@/app/agent-queue/loading"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/agent-queue/")({
  component: PageComponent,
  pendingComponent: Pending,

})

function PageComponent() {
  usePageHead({ title: "Agent Runs" })
  return <Page />
}
